var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_c('h3',{staticClass:"py-3"},[_c('b-icon',{attrs:{"icon":"chevron-right"}}),_vm._v(" "),_vm._t("default")],2)]),_vm._v(" "),_c('div',[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }